import * as React from 'react'

import { observer } from 'mobx-react'

import LocationCard from '../../SitemapCards/LocationCard'
import MapViewItemBase from '../../SitemapHelpers/models/MapViewItemBase'
import SitemapDraggableModalWrapper from '../SitemapDraggableModalWrapper'

interface IProps {
  item: MapViewItemBase
  containerRef: HTMLElement

  onClose(): void

  topOffset: number
  leftOffset: number

  selectedStartDate?: Date
  selectedEndDate?: Date

  onPlusButtonClick?: () => void
}

// localization: no text to translate

@observer
export default class SitemapLocationModal extends React.Component<IProps> {
  public render() {
    const {
      containerRef,
      onClose,
      topOffset,
      leftOffset,
      item,
      selectedStartDate,
      selectedEndDate,
      onPlusButtonClick,
    } = this.props

    return (
      <SitemapDraggableModalWrapper
        className="overflow-auto brada10 short-modal"
        item={item}
        containerRef={containerRef}
        onClose={onClose}
        topOffset={topOffset}
        leftOffset={leftOffset}
        isStatic={true}
      >
        <LocationCard
          item={item}
          onPlusButtonClick={onPlusButtonClick}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
        />
      </SitemapDraggableModalWrapper>
    )
  }
}
